// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ji-0";
export var fileList = "_ji-2";
export var removeFileButton = "_ji-1";